import { ERRORS } from "./constants";

/*
 * Convert a back-end error message to a human readable one.
 *
 * @param {string} error - the backend code (e.g., E_FILE_TOO_SMALL)
 * @returns {string} message - the human readable code (e.g., "Dat file too
 *   small yo")
 */
export function getPhotoError(err) {
	if (ERRORS[err]) {
		return ERRORS[err].desc;
	} else {
		return ERRORS.DEFAULT.desc;
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUpload/util.js